// @flow

import React from 'react'
import { Images } from '@/constants'
import { classnames } from '@/helpers'
import styles from './styles.scss'

type ErrorBarProps = {|
  error: string,
  className: ?string,
|}

const ErrorBar = (props: ErrorBarProps) => {
  const { error, className } = props
  return (
    <div className={classnames(styles.errorBar, className)}>
      <img src={Images.alert} alt="error-alert" />
      <h5 className={styles.errorText} dangerouslySetInnerHTML={{ __html: error }} />
    </div>
  )
}

ErrorBar.defaultProps = {
  className: '',
}

export default ErrorBar
